import axios from "axios";

export const getCustStatistik = async (year, month) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `https://api.wifikamu.my.id/customer-statistik?year=${year}&month=${month}`,
    {
      headers: {
        Authorization: token,
      },
    }
  );

  return response.data.data;
};
